import Glide from '@glidejs/glide'
//import { updateFadeSlider } from './slider-utils';

const unleashFrankenstein = () => {
    let block = document.querySelector(".js-frankenstein-glide");
    if (!block) return;
    let frankenGlide;

    const reloadSlider = () => {
        //console.log("reloading frankenglide");
        if (frankenGlide) {
            //console.log("disabling frankenglide")
            frankenGlide.disable()
        }
        let gliderRoot = block.querySelector(".glide");
        if (!gliderRoot) return;

        let options = {
            type: 'slider',
            perView: 4,
            focusAt: 1,
            autoplay: 0,
            animationDuration: 1200,
            perTouch: false,
            touchRatio: 0.75,
            gap: 35,
            breakpoints: {
                1024: {
                    focusAt: 0,
                    gap: 35,
                    perView: 2,
                    peek: { before: 34, after: 34 }
                },
                800: {
                    focusAt: 0,
                    gap: 35,
                    perView: 1,
                    peek: { before: 100, after: 100 }
                },
                640: {
                    focusAt: 0,
                    gap: 20,
                    perView: 1,
                    peek: { before: 50, after: 50 }
                },
                500: {
                    focusAt: 0,
                    gap: 10,
                    perView: 1,
                    peek: { before: 20, after: 20 }
                }
            }


        }

        frankenGlide = new Glide(gliderRoot, options);


        frankenGlide.on('mount.after', function () {
            gliderRoot.classList.add('mounted')
        })

        frankenGlide.on('run', (event) => {

            //console.log(event);
            //console.log(frankenGlide.index);
            //updateNumbers(glide.index);
            //updateBar(glide.index);
            //updateFaces(glide.index);
            //updateTexts(glide.index);
            //updateButtons(glide.index);

        })

        frankenGlide.mount()
        //console.log(frankenGlide)

        let left = block.querySelectorAll(".js-left");
        let right = block.querySelectorAll(".js-right");
        if (left) {
            left.forEach((element) => {
                element.removeEventListener("click", () => { frankenGlide.go("<") })
                element.addEventListener("click", () => { frankenGlide.go("<") })
            });

        }
        if (right) {
            right.forEach((element) => {
                element.removeEventListener("click", () => { frankenGlide.go("<") })
                element.addEventListener("click", () => { frankenGlide.go(">") })
            });
        }
    }



    function checkAndObserve() {
        // Store the initial state of each element
        const elementStates = new Map();

        // Setup a MutationObserver
        const observer = new MutationObserver((mutations) => {
            mutations.forEach(mutation => {
                if (mutation.type === 'attributes' && mutation.attributeName === 'class') {
                    const target = mutation.target;
                    const hasWpgbLoading = target.classList.contains('wpgb-loading');
                    const prevState = elementStates.get(target) || false;

                    // Update state and call reloadSlider if state changed
                    if (prevState !== hasWpgbLoading) {
                        elementStates.set(target, hasWpgbLoading);
                        if (!hasWpgbLoading) {
                            reloadSlider();
                        }
                    }
                }
            });
        });

        // Observe all elements with the class 'js-observed-grid'
        document.querySelectorAll('.js-observed-grid').forEach(el => {
            // Initialize state map and observe element
            const hasWpgbLoading = el.classList.contains('wpgb-loading');
            elementStates.set(el, hasWpgbLoading);
            observer.observe(el, { attributes: true });

            // Call reloadSlider if element doesn't have 'wpgb-loading' class
            if (!hasWpgbLoading) {
                reloadSlider();
            }
        });
    }


    // Call the function when appropriate in your application's lifecycle
    checkAndObserve();

}

export { unleashFrankenstein }
